import React from 'react'
import Uppy from '@uppy/core'
import { DragDrop, ProgressBar  } from '@uppy/react'


import '@uppy/core/dist/style.css'
import '@uppy/drag-drop/dist/style.css'
import '@uppy/progress-bar/dist/style.css'

export function Uploader({ onFileAdded }) {
  

    const uppy = new Uppy({

        restrictions: { 
          maxNumberOfFiles: 1,
          allowedFileTypes: ['.csv','.xlsx']
        },
        autoProceed: false
    })
    
    uppy.on('file-added', (file) => {

        var reader = new FileReader();
        reader.onload = function() {
            var binary = '';
            var bytes = new Uint8Array(reader.result);
            var len = bytes.byteLength;
            for (var i = 0; i < len; i++) {
                binary += String.fromCharCode(bytes[i]);
            }

            onFileAdded(window.btoa(binary), file.name);

            uppy.removeFile(file.id)
        }
        reader.readAsArrayBuffer(file.data);

      })

    uppy.on('complete', (result) => {
    })

  return (
  <>
    <DragDrop
        uppy={uppy}
        locale={{
          strings: {
            // Text to show on the droppable area.
            // `%{browse}` is replaced with a link that opens the system file selection dialog.
            dropHereOr: 'Drop here or %{browse}',
            // Used as the label for the link that opens the system file selection dialog.
            browse: 'browse'
          }
        }} 
      />

      <ProgressBar
        uppy={uppy}
        fixed
        hideAfterFinish
      />
  </>
  );
}